import { Component, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { OverlayService } from '../../../services/overlay.service';
import { SapiService } from '../../../services/sapi.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';


@Component({
	selector: 'bb-create-preset',
	templateUrl: './bb-create-preset.component.html',
	styleUrls: ['./bb-create-preset.component.scss']
})

export class BbCreatePresetComponent implements OnInit, OnDestroy {
	@Output() modalClose: EventEmitter<string> = new EventEmitter<string>();
	presetName: string;
	assets = [];
	columsToDisplay = [' ', 'ASSET_TYPE', 'NAME', 'LABEL', 'BITRATE'];
	selectedJobDefinitions = [];

	private subscriptions = new Subscription();

	constructor(
		private sapiService: SapiService,
		private translate: TranslateService,
		private overlayService: OverlayService) {
	}

	ngOnInit() {
		this.presetName = 'New Preset';
		this.sapiService.getUrl('/mediajobdef').subscribe((mediaclipJobs: any) => {
			if (mediaclipJobs && mediaclipJobs.items) {
				mediaclipJobs.items.forEach((item) => {
					const height = parseInt(item.height, 10);
					const title = (height > 0) ? (Math.ceil(height / 120) * 120).toString() + 'p' : '';
					item.title = title;
					this.assets.push(item);
				});
			}
		});
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	assetsChanged(asset, event) {
		if (event) {
			this.selectedJobDefinitions.push(asset);
		} else {
			const removeAsset = this.selectedJobDefinitions.indexOf(asset);
			if (removeAsset > -1) {
				this.selectedJobDefinitions.splice(removeAsset, 1);
			}
		}
	}

	onSaveClick() {
		if (this.presetName && this.selectedJobDefinitions.length !== 0) {
			const params = {
				type: 'Profile',
				status: 'active',
				name: this.presetName,
				label: 'Custom',
				items: this.selectedJobDefinitions
			};

			this.sapiService.putUrl('/mediaprofile', params).subscribe(() => {
				this.overlayService.createToast(this.translate.instant('ENTITY_SAVED', {
					entity: this.translate.instant('PRESET').toLowerCase(),
					id: this.presetName
				}), 'save');
				setTimeout(() => {
					this.modalClose.emit(this.presetName);
				}, 1000);
			},
			(err) => {
				this.overlayService.createToast(this.translate.instant('ERROR'), 'warning');
			}
			);
		} else {
			this.overlayService.createToast(this.translate.instant('COULD_NOT_SAVE_ENTITY_BECAUSE_REQUIRED_FIELDS2',
				{ entity: this.translate.instant('PRESET').toLowerCase() }), 'times-circle');
		}
	}
}
